import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

//OneLogin
import { finalize } from 'rxjs/operators';
import { SpinnerService } from '../services/spinner.service';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

  constructor(private __spinnerService: SpinnerService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let requestToken = request;
    this.__spinnerService.show();
    //Agrega header azure microservices
    requestToken = request.clone({
      setHeaders: {
      }
    })
    return next.handle(requestToken).pipe(
      finalize(() => this.__spinnerService.hide())
    );
  }
}
